import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ProjectHero from '../components/ProjectCasePage/ProjectHero/ProjectHero';
import ProjectVisual from '../components/ProjectCasePage/ProjectVisual/ProjectVisual';
import ProjectInfoBar from '../components/ProjectCasePage/ProjectInfoBar/ProjectInfoBar';
import ProjectIntroAccordion from '../components/ProjectCasePage/ProjectIntroAccordion/ProjectIntroAccordion';
import ProjectResultsAccordion from '../components/ProjectCasePage/ProjectResultsAccordion/ProjectResultsAccordion';
import ComparisonGallery from '../components/ProjectCasePage/ComparisonGallery/ComparisonGallery';
import ResultGallery from '../components/ProjectCasePage/ResultGallery/ResultGallery';
import ProjectMetrics from '../components/ProjectCasePage/ProjectMetrics/ProjectMetrics';
import ProjectEstimateCTA from '../components/ProjectCasePage/projectEstimateCTA/ProjectEstimateCTA';
import ScrollToggle from '../components/HomePage/ScrollToggle/ScrollToggle';
import { getProjectById } from '../data/projects';
import '../components/ProjectCasePage/projectSections.css';

const Project = () => {
  const { id } = useParams();
  const project = getProjectById(id);
  const usesProject01Template = project?.template === 'project-01';

  useEffect(() => {
    if (!project?.seo) return undefined;
    const previousTitle = document.title;
    document.title = project.seo.title;
    let description = document.querySelector('meta[name="description"]');
    const previousDescription = description?.getAttribute('content');
    if (!description) {
      description = document.createElement('meta');
      description.setAttribute('name', 'description');
      document.head.appendChild(description);
    }
    description.setAttribute('content', project.seo.description);
    return () => {
      document.title = previousTitle;
      if (previousDescription) description.setAttribute('content', previousDescription);
    };
  }, [project]);

  if (!project) {
    return <main className="section"><div className="container"><h1 className="title-1">Проект не найден</h1></div></main>;
  }

  return (
    <>
      <main className="section">
        <div className="container">
          <div
            className={`project-top${usesProject01Template ? ' project-top--mobile-reordered' : ''}`}
            data-project-id={project.id}
          >
            <ProjectHero data={project.hero} projectId={project.id} />
            <ProjectVisual data={project.visual} projectId={project.id} useContainedMedia={usesProject01Template} />
            <ProjectInfoBar data={project.info} />
          </div>
          <ProjectIntroAccordion project={project} projectId={project.id} enabled={usesProject01Template} />
          <ComparisonGallery
            data={project.comparisonGallery}
            projectId={project.id}
            useProject01Template={usesProject01Template}
          />
          <ResultGallery data={project.resultGallery} projectId={project.id} />
          <section className="project-results-row project-intro-accordion">
            <ProjectResultsAccordion
              project={project}
              projectId={project.id}
              enabled={usesProject01Template}
            />
            <ProjectMetrics data={project.metrics} projectId={project.id} useProject01Template={usesProject01Template} />
          </section>
          <ProjectEstimateCTA data={project.estimateCta} projectId={project.id} useProject01Template={usesProject01Template} />
        </div>
      </main>
      <ScrollToggle labels={project.scrollToggleLabels} />
    </>
  );
};

export default Project;
